// Helpers de apresentação de texto.

// Corta `text` em `max` caracteres tentando respeitar fronteira de palavra,
// adicionando reticências ao final. Usado nos cards de listagem para que
// descrições longas vindas do CMS não estourem o layout — a descrição
// completa fica disponível na página de detalhe (Saiba mais).
export function truncate(text, max = 150) {
  if (!text) return "";
  if (text.length <= max) return text;
  const slice = text.slice(0, max);
  const lastSpace = slice.lastIndexOf(" ");
  const cut = lastSpace > Math.floor(max * 0.6) ? slice.slice(0, lastSpace) : slice;
  return cut.trimEnd().replace(/[.,;:!?-]+$/, "") + "…";
}
